import { Icons, Typography, Box, Stack, tokens } from '@cast/design-system';

type IconRowProps = {
  icon: React.ReactNode;
  label: string;
};

const IconRow = ({ icon, label }: IconRowProps) => (
  <Stack direction="row" gap={8} py={7} alignItems="center">
    {icon}
    <Typography
      variant="P12R"
      color={tokens.theme.fg.structural.primaryOnInverse}
    >
      {label}
    </Typography>
  </Stack>
);

export const DifferenceTooltip = () => {
  return (
    <>
      <Typography
        variant="P12R"
        color={tokens.theme.fg.structural.primaryOnInverse}
      >
        Scaling difference in resources between requested and recommended.
      </Typography>
      <Stack bgcolor="grey.700" mx={-8} px={8}>
        <IconRow
          icon={
            <Box
              sx={{
                borderRadius: '24px',
                bgcolor: tokens.theme.bg.structural.surface,
                display: 'flex',
              }}
            >
              <Icons.CaretDown
                size={16}
                weight="fill"
                // No suitable semantic fg token at green.500 (closest success is green.800).
                color={tokens.primitives.colors.green[500]}
              />
            </Box>
          }
          label="Downscaling"
        />
        <IconRow
          icon={
            <Box
              sx={{
                borderRadius: '24px',
                bgcolor: tokens.theme.bg.structural.surface,
                display: 'flex',
              }}
            >
              <Icons.CaretUp
                size={16}
                weight="fill"
                color={tokens.theme.fg.structural.primary}
              />
            </Box>
          }
          label="Upscaling"
        />
      </Stack>
    </>
  );
};
